import React, { useState, useEffect } from "react";
import Loading from "../../Common/Loading";
import { useNavigate } from "react-router-dom";
import popimg from "../../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../../Common/Images/ImagesForAlert/popup_close_n.png";
import EL_AddModifyUpdates from "./EL_AddModifyUpdates";
import CustomAlert from "../../Common/CustomAlert";
interface UpdateRecord {
  ID: number;
  UpdatedOn: string;
  Subject: string;
  Year: string;
  Curriculum: string;
  Country: string;
  Status: string;
  Description: string;
}

const EL_ShowUpdates: React.FC = () => {
  const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

  const [updates, setUpdates] = useState<UpdateRecord[]>([]);
  const [selectedRecord, setSelectedRecord] = useState<UpdateRecord | null>(
    null,
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalMode, setModalMode] = useState<"ADD" | "EDIT">("ADD");
  const [alertInfo, setAlertInfo] = useState({ show: false, message: "" });
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.margin = "0px";
    document.body.style.fontFamily = "Arial, sans-serif";
    document.body.style.backgroundColor = "azure";
    fetchUpdates();
  }, []);

  // Helper to format dates as DD/MM/YYYY HH:MM:SS
  const pad = (n: number) => n.toString().padStart(2, "0");
  const formatDate = (input: any) => {
    if (!input && input !== 0) return "";
    let dt: Date;
    try {
      if (typeof input === "string" && input.indexOf("/Date(") === 0) {
        const ms = parseInt((input.match(/\d+/) || ["0"])[0], 10);
        dt = new Date(ms);
      } else {
        dt = new Date(input);
      }
      if (isNaN(dt.getTime())) return String(input);
      return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()} ${pad(
        dt.getHours(),
      )}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;
    } catch (e) {
      return String(input);
    }
  };

  const fetchUpdates = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}api/updates/list`);
      const json = await res.json();
      if (json.error) throw new Error(json.error);

      // Normalize, format dates and ensure numeric ID
      let fetched = (json.updates || []).map((u: any) => ({
        ...u,
        ID: Number(u.ID),
        UpdatedOn: formatDate(u.UpdatedOn),
      }));

      // Sort by ID ascending (smallest ID first)
      fetched.sort((a: any, b: any) => (a.ID || 0) - (b.ID || 0));

      setUpdates(fetched);
    } catch (err) {
      setErrorMsg("Error loading updates.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setSelectedRecord(null);
    setModalMode("ADD");
    setIsModalOpen(true);
  };

const handleEdit = () => {
    // if (updates.length === 0) return;
    if (!selectedRecord) {
        setAlertInfo({ show: true, message: "Please Select a Row." });
        return;
    }

    const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"
    setSelectedRecord({ ...selectedRecord, UpdatedOn: today });

    setModalMode("EDIT");
    setIsModalOpen(true);
};

  const handleClose = () => {
    navigate("/SysAdmin");
  };

  const handleModalClose = (shouldRefresh: boolean = false) => {
    setIsModalOpen(false);
    if (shouldRefresh) {
      fetchUpdates();
    }
  };

  const styles = {
    container: { padding: "10px" },

    gridWrapper: {
      overflowY: "auto" as const,
      height: "calc(100vh - 180px)",
      border: "1px solid #A0A0A0",
      marginBottom: "15px",
    },
    gridTable: {
      width: "100%",
      borderCollapse: "collapse" as const,
      fontSize: "10pt",
      fontFamily: "Arial",
      border: "1px solid #a3c0e8",
    },

    gridTh: {
      backgroundColor: "#c7ddfd",
      color: "#2859ac",
      padding: "10px",
      textAlign: "center" as const,
      fontWeight: "normal",
      position: "sticky" as const,
      top: 0,
      border: "1px solid #a3c0e8",
    },
    gridTdCenter: {
      padding: "8px",
      borderLeft: "1px solid #a3c0e8",
      textAlign: "center" as const,
      cursor: "pointer",
      whiteSpace: "nowrap" as const,
      fontFamily: "Arial",
      fontsize: "10pt",
    },
    gridTdLeft: {
      padding: "8px",
      borderLeft: "1px solid #a3c0e8",
      textAlign: "left" as const,
      cursor: "pointer",
      whiteSpace: "nowrap" as const,
      fontFamily: "Arial",
      fontsize: "10pt",
    },

    selectedRow: { backgroundColor: "#FFA500", color: "white" },
    altRow: { backgroundColor: "#f4faff" },
    defaultRow: { backgroundColor: "white" },

    buttonPanel: { textAlign: "center" as const },
    btn: {
      width: "100px",
      cursor: "pointer",
      padding: "4px",
      margin: "0 10px",
      fontFamily: "Arial",
    },
  };

  return (
    <div style={styles.container}>
      {loading && <Loading />}

      {isModalOpen && (
        <EL_AddModifyUpdates
          initialData={modalMode === "EDIT" ? selectedRecord : null}
          onClose={handleModalClose}
        />
      )}
      {alertInfo.show && (
        <CustomAlert
          message={alertInfo.message}
          onClose={() => setAlertInfo({ ...alertInfo, show: false })}
        />
      )}

      <div
        style={{
          backgroundImage: `url(${popimg}), url(${popbg})`,
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundPosition: "left center, right center",
          backgroundSize: "30% 100%, 70% 100%",
          height: "16px",
          color: "white",
          padding: "7px 0px",
          fontWeight: "bold",
          fontSize: "13pt",
          fontFamily: "arial",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span style={{ marginLeft: "10px" }}>Program Updates</span>
        <img
          src={popclose}
          alt="close"
          height="30px"
          style={{ cursor: "pointer" }}
          onClick={handleClose}
        />
      </div>

      {errorMsg && (
        <div
          style={{ color: "red", fontWeight: "bold", paddingBottom: "10px" }}
        >
          {errorMsg}
        </div>
      )}

      <div style={styles.gridWrapper}>
        <table style={styles.gridTable}>
          <thead>
            <tr>
              <th style={{ ...styles.gridTh, width: "3%" }}>#</th>
              <th style={{ ...styles.gridTh, width: "5%" }}>ID</th>
              <th
                style={{ ...styles.gridTh, width: "8%", whiteSpace: "nowrap" }}
              >
                UpdatedOn
              </th>
              <th style={{ ...styles.gridTh, width: "12%" }}>Subject</th>
              <th style={{ ...styles.gridTh, width: "5%" }}>Year</th>
              <th style={{ ...styles.gridTh, width: "12%" }}>Curriculum</th>
              <th style={{ ...styles.gridTh, width: "8%" }}>Country</th>
              <th style={{ ...styles.gridTh, width: "6%" }}>Status</th>
              <th
                style={{ ...styles.gridTh, textAlign: "left", width: "auto" }}
              >
                Description
              </th>
            </tr>
          </thead>
          <tbody>
            {updates.map((row, idx) => {
              const isSelected = selectedRecord?.ID === row.ID;
              return (
                <tr
                  key={row.ID}
                  onClick={() => setSelectedRecord(row)}
                  style={
                    isSelected
                      ? styles.selectedRow
                      : idx % 2 === 0
                        ? styles.defaultRow
                        : styles.altRow
                  }
                >
                  <td style={styles.gridTdCenter}>{idx + 1}</td>
                  <td style={styles.gridTdCenter}>{row.ID}</td>
                  <td style={{ ...styles.gridTdCenter, whiteSpace: "nowrap" }}>
                    {row.UpdatedOn}
                  </td>
                  <td style={styles.gridTdCenter}>{row.Subject}</td>
                  <td style={styles.gridTdCenter}>{row.Year}</td>
                  <td style={styles.gridTdCenter }>
                    {row.Curriculum}
                  </td>
                  <td style={styles.gridTdCenter}>{row.Country}</td>
                  <td style={styles.gridTdCenter}>{row.Status}</td>
                  <td style={styles.gridTdLeft}>{row.Description}</td>
                </tr>
              );
            })}
            {updates.length === 0 && !loading && (
              <tr>
                <td
                  colSpan={9}
                  style={{ padding: "20px", textAlign: "center" }}
                >
                  No updates found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div style={styles.buttonPanel}>
        <table style={{ margin: "0 auto", border: 0 }}>
          <tbody>
            <tr>
              <td style={{ width: "140px", textAlign: "center" }}>
                <button style={styles.btn} onClick={handleAdd}>
                  Add
                </button>
              </td>
              <td style={{ width: "140px", textAlign: "center" }}>
                <button style={styles.btn} onClick={handleEdit}>
                  Edit
                </button>
              </td>
              <td style={{ width: "140px", textAlign: "center" }}>
                <button style={styles.btn} onClick={handleClose}>
                  Close
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EL_ShowUpdates;
